import React from "react";

// import Email from "./components/email";
import Password from "./components/password";
import Timezone from "./components/timezone";
// import Industry from "./components/industry";
// import Newsletter from "./components/newsletter";
import { useUserDataStore } from "../../../store/userData";

interface Props {}

const Settings: React.FC<Props> = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-xxl-4 col-lg-6 mx-auto">
                        {/* <div className="_card">
                            <h4>Update timezone</h4>
                            <Timezone />
                        </div> */}
                        {/* <div className="_card">
                            <h4>Newsletter</h4>
                            <Newsletter />
                        </div> */}
                        {/* <div className="_card">
                            <h4>Update email</h4>
                            <Email />
                        </div> */}
                        <div className="_card">
                            <h4>Update password</h4>
                            <Password />
                        </div>
                        <div className="_card">
                            <a href="/">Go to VCA</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Settings;
